<template>
    <div class="map-container">
        <div class="section-title">병원 소개</div>
        <div ref="mapEl" class="map"></div>
        <div class="address-row">
            <span class="address-text">{{ address }}</span>
            <div class="copy-button" @click="copyAddress">주소복사</div>
        </div>
        <transition name="toast-fade">
            <div class="toast" v-if="showToast">
                <span class="toast-message">주소를 복사하였습니다.</span>
                <div class="toast-close" @click="closeToast">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M4 4L12 12M12 4L4 12" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['address'],
    data() {
        return {
            showToast: false,
            toastTimer: null
        }
    },
    mounted() {
        this.initMap();
    },
    beforeDestroy() {
        if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    methods: {
        async initMap() {
            if (!this.address) return;

            const kakaoApiKey = process.env.KAKAO_REST_API_KEY;
            const url = `https://dapi.kakao.com/v2/local/search/address.json?query=${encodeURIComponent(this.address)}`;

            try {
                const response = await fetch(url, {
                    headers: { 'Authorization': `KakaoAK ${kakaoApiKey}` }
                });
                const data = await response.json();

                let lat = 37.5665;
                let lng = 126.9780;

                if (data.documents && data.documents.length > 0) {
                    lat = parseFloat(data.documents[0].y);
                    lng = parseFloat(data.documents[0].x);
                }

                this.renderMap(lat, lng);
            } catch (e) {
                this.renderMap(37.5665, 126.9780);
            }
        },
        renderMap(lat, lng) {
            if (!window.naver || !window.naver.maps) return;

            const center = new naver.maps.LatLng(lat, lng);
            const map = new naver.maps.Map(this.$refs.mapEl, {
                center: center,
                zoom: 16,
                logoControl: false,
                mapDataControl: false,
                scaleControl: false,
                zoomControl: false
            });
            new naver.maps.Marker({
                map: map,
                position: center
            });
        },
        copyAddress() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.address);
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = this.address;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }
            this.showToastMessage();
        },
        showToastMessage() {
            if (this.toastTimer) clearTimeout(this.toastTimer);
            this.showToast = true;
            this.toastTimer = setTimeout(() => {
                this.showToast = false;
            }, 5000);
        },
        closeToast() {
            if (this.toastTimer) clearTimeout(this.toastTimer);
            this.showToast = false;
        }
    }
}
</script>

<style scoped>
.map-container {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 6px;
    background: var(--gray-00, #FFF);
    box-shadow: 0 0 10px 0 rgba(0, 33, 56, 0.09);
    margin-top: 16px;
}

.section-title {
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 125% */
    margin-bottom: 16px;
}

.map {
    width: 100%;
    height: 144px;
    overflow: hidden;
}

.address-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 8px;
    gap: 12px;
}

.address-text {
    color: var(--Gray-60, #6B7684);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
}

.copy-button {
    flex-shrink: 0;
    border-radius: 100px;
    background: var(--Gray-20, #F3F5F8);
    display: flex;
    height: 28px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 65px;
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
}

.toast {
    position: fixed;
    bottom: 57px;
    left: 16px;
    right: 16px;
    max-width: 568px;
    margin: 0 auto;
    height: 57px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    border-radius: 6px;
    background: rgba(87, 87, 87, 0.85);
    backdrop-filter: blur(2px);
    z-index: 9999;
}

.toast-message {
    color: #FFF;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}

.toast-close {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 4px;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
    transition: opacity 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/hospital/Map.vue